module.exports = __webpack_public_path__ + "img/shape-4-mobile-gold@2x.3e15c258.png";